<template>
  <div class="container pad120">
    <img
      class="banner"
      v-if="bannerList.length && bannerList[0].url"
      v-lazy="bannerList[0].url"
    />
    <!-- 长页面的其他内容 -->
    <div
      v-for="(item, index) in 5"
      :key="index"
      class="content-item"
      ref="targetElement"
      :data-index="index"
    >
      <template v-if="index == 0">
        <div v-show="isVisibleFlag[index]" :class="['boxes']">
          <!-- 我们提供的服务 -->
          <div class="content" style="align-items: flex-end; background: #fff">
            <div class="box">
              <div class="title animate__zoomInLeft animate__animated">
                <div>用心服务，成就您的每一步</div>
              </div>
              <div class="serviceCont">
                <ul class="animate__zoomInRight animate__animated">
                  <li
                    :key="index1"
                    v-for="(item, index1) in tabList"
                    @click="changeTab(index1)"
                  >
                    <span class="decoration"></span>

                    <div class="name">{{ item.name }}</div>
                    <div class="tags">
                      <div :key="index2" v-for="(inner, index2) in item.list">
                        <div :key="index3" v-for="(last, index3) in inner">
                          <span></span>
                          {{ last }}
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <img
                  class="mid animate__bounceIn animate__animated"
                  src="../../assets/ui3/1.png"
                  alt=""
                />
                <ul class="animate__zoomInRight animate__animated">
                  <li
                    :key="index1"
                    v-for="(item, index1) in tabList1"
                    @click="changeTab(index1)"
                  >
                    <span class="decoration"></span>

                    <div class="name">{{ item.name }}</div>
                    <div class="tags">
                      <div :key="index2" v-for="(inner, index2) in item.list">
                        <div :key="index3" v-for="(last, index3) in inner">
                          <span></span>
                          {{ last }}
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="index == 1">
        <div v-show="isVisibleFlag[index]" :class="['boxes']">
          <!-- 数据智能解决方案，赋能千百行业 -->
          <div ref="targetElement1" class="content" style="background: #f3f4f8">
            <div class="box">
              <div class="title animate__zoomInLeft animate__animated">
                <div>数据智能解决方案，赋能千百行业</div>
              </div>
              <div class="case">
                <div class="caseWrap animate__bounceIn animate__animated">
                  <div
                    @click="detail(item)"
                    class="item"
                    :key="index"
                    v-for="(item, index) in bannerList1"
                  >
                    <div class="pic">
                      <img :src="item.url" alt="" />
                    </div>
                    <div class="infoWrap">
                      <div class="name1">{{ item.caseTitle }}</div>
                      <div class="desc">{{ item.projectDescribe }}</div>
                      <div class="detail">
                        了解详情
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="index == 2">
        <div v-show="isVisibleFlag[index]" :class="['boxes']">
          <!-- news -->
          <div class="news content" ref="targetElement2">
            <div class="box">
              <div class="title animate__zoomInLeft animate__animated">
                <div>为什么选择我们</div>
              </div>

              <div class="whychoice animate__animated animate__backInLeft">
                <div>
                  <img src="../../assets/ui3/c1.png" alt="" />
                  <div class="info">
                    <div class="name1">前沿的技术创新力</div>
                    <div class="desc">
                      我们紧跟科技前沿，掌握最新的软件开发技术，尤其在云计算、大数据、人工智能、区块链等领域有深入研究和应用，获得用户的一致好评。
                    </div>
                  </div>
                </div>
                <div>
                  <img src="../../assets/ui3/c2.png" alt="" />
                  <div class="info">
                    <div class="name1">丰富的项目经验</div>
                    <div class="desc">
                      我们的团队由经验丰富的工程师、项目经理和架构师组成，具备扎实的技术背景和丰富的项目经验，能够为客户提供专业的技术支持和解决方案。
                    </div>
                  </div>
                </div>
                <div>
                  <img src="../../assets/ui3/c3.png" alt="" />
                  <div class="info">
                    <div class="name1">强大的安全体系</div>
                    <div class="desc">
                      强大的安全体系，结合高效的管理与技术手段，保护用户数据安全，保障企业的信息和资产安全。
                    </div>
                  </div>
                </div>
              </div>

              <div class="title animate__zoomInLeft animate__animated">
                <div>了解最新动态</div>
                <div
                  @click="zixun"
                  style="padding-bottom: 0; cursor: pointer"
                  class="slogan"
                >
                  更多资讯<i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="innerBox animate__animated animate__backInLeft">
                <div
                  class="items"
                  @click="getNewList1(item)"
                  :key="index"
                  v-for="(item, index) in newsList"
                >
                  <div class="info">
                    <div class="name">{{ item.title }}</div>

                    <div class="detail">
                      {{ item.introduction }}
                    </div>
                    <div class="bottom">
                      <div class="left">
                        {{ item.publishDate }}
                      </div>
                    </div>
                    <div class="line1"></div>
                    <div class="more1">
                      <img src="../../assets/ui3/4.png" alt="" />
                      MORE
                    </div>
                    <div class="bor"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="index == 3">
        <div v-show="isVisibleFlag[index]" :class="['boxes']">
          <!-- 合作伙伴 -->
          <div
            ref="targetElement3"
            class="coperrator content animate__animated animate__backInRight"
            style="position: relative"
          >
            <img
              src="../../assets//ui3/3.png"
              style="display: block; width: 100%"
              alt=""
            />
            <div
              style="
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                display: flex;
                align-items: center;
              "
            >
              <div class="box" style="margin: 0 auto">
                <div class="title">
                  <div>合作伙伴</div>
                  <!-- <div class="line"></div> -->
                </div>
                <div class="slogan"></div>
                <div class="box1">
                  <img src="../../assets/ui3/f1.png" alt="" />
                  <img src="../../assets/ui3/f2.png" alt="" />
                  <img src="../../assets/ui3/f3.png" alt="" />
                  <img src="../../assets/ui3/f4.png" alt="" />
                  <img src="../../assets/ui3/f5.png" alt="" />
                  <img src="../../assets/ui3/f6.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="index == 4">
        <div v-show="isVisibleFlag[index]" :class="['boxes', 'addr']">
          <!-- 我们提供的服务 -->
          <div class="content" style="align-items: flex-end">
            <div
              ref="targetElement4"
              class="box animate__zoomInUp animate__animated"
              style="padding-bottom: 0"
            >
              <div class="title">
                <div>公司地址</div>
                <!-- <div class="line"></div> -->
              </div>
              <!-- <div class="slogan"></div> -->

              <div class="mapBox">
                <div class="infobox">
                  <div>
                    <img class="addricon" src="../../assets/ui3/addricon.png" alt="">
                    <div class="zh">西安荣业信息科技有限公司</div>
                    <div class="en">
                      Xi 'an Rongye lnformation Technology Co.,LTD
                    </div>
                    <div style="padding-top: 8px" class="Certificates">
                      {{ info.companySlogan }}
                    </div>
                  </div>
                  <div class="info info1">
                    <div>公司地址：{{ info.companyAddress }}</div>
                    <div>联系电话：{{ info.phone }}</div>
                    <div>电子邮箱：{{ info.email }}</div>
                  </div>
                </div>
                <!-- <img src="../../assets/dw.png" alt="" /> -->
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <el-dialog
      title=""
      :visible.sync="isVisible"
      width="100%"
      @close="closeModal"
    >
      <img
        style="width: 100%; display: block; height: auto"
        :src="hdImg"
        alt=""
      />
    </el-dialog>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import boxTitle from "@/components/common/box-title";
import moreButton from "@/components/common/more-button";
import projectItem from "@/components/common/project-item";
import caseItem from "@/components/common/case-item";
import HonorItem from "@/components/common/honor-item";

import {
  banners,
  companyInfo,
  permissions,
  information,
  getTodayHoliday,
} from "@/api/api";

export default {
  components: {
    HonorItem,
    boxTitle,
    moreButton,
    projectItem,
    caseItem,
  },
  data() {
    return {
      isVisibleFlag: Array(5).fill(false), // 控制每个元素的可见状态
      hdImg: "",
      isVisible: false,

      casecur: 0,
      tabList: [
        {
          name: "APP开发",
          list: [
            ["APP开发", " UI界面设计"],
            ["PAD界面设计", "移动产品设计"],
          ],
        },
        {
          name: "解决方案",
          list: [
            ["O2O电商平台", "智慧社区"],
            ["P2P金融", "防伪溯源"],
          ],
        },
      ],
      tabList1: [
        {
          name: "网站建设",
          list: [
            ["品牌&企业网站", "H5响应式网站"],
            ["品牌营销型网站", "集团&上市公司网站"],
          ],
        },
        {
          name: "H5微营销",
          list: [
            ["微信商城", "微官网设计"],
            ["微应用定制", "微信公众号托管"],
          ],
        },
      ],
      // 动画
      flag1: false,
      flag2: false,
      newsList: [],
      curnewsIndex: 0,
      curnewInfo: {},
      curIndex: 0,
      cur: 0,
      caseList: [],
      bannerList: [],
      bannerList1: [],
      curInfo: {},
      info: {},
    };
  },
  mounted() {
    // 创建 IntersectionObserver 实例
    const observer = new IntersectionObserver(this.handleIntersection, {
      root: null, // 观察视口
      rootMargin: "0px", // 触发时机为进入视口
      threshold: 0.1, // 元素 10% 进入视口时触发
    });

    // 观察每个目标元素
    this.$nextTick(() => {
      const targetElements = this.$refs.targetElement;
      targetElements.forEach((element, index) => {
        observer.observe(element);
      });
    });

    this.FngetTodayHoliday();
    this.getpermissions();
    this.getBanner();
    this.getcompanyInfo();
    this.getNewsList();
  },
  methods: {
    // 处理元素进入视口时的回调
    handleIntersection(entries) {
      entries.forEach((entry) => {
        const index = entry.target.dataset.index;
        if (entry.isIntersecting) {
          // 进入视口时，显示该元素并启动动画
          this.$set(this.isVisibleFlag, index, true);
        }
      });
    },

    // 获取当前日期（格式：YYYY-MM-DD）
    getCurrentDate() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },
    // 关闭弹框并记录当前日期
    closeModal() {
      const currentDate = this.getCurrentDate();
      localStorage.setItem("lastClosedDate", currentDate); // 存储日期
      this.isVisible = false; // 关闭弹框
    },
    // 判断是否需要展示弹框
    shouldShowModal() {
      const lastClosedDate = localStorage.getItem("lastClosedDate");
      const currentDate = this.getCurrentDate();

      // 如果没有记录过关闭日期，或者日期不一样（即已经是新的一天）
      if (!lastClosedDate || lastClosedDate !== currentDate) {
        return true; // 可以展示弹框
      }
      return false; // 不展示弹框
    },
    FngetTodayHoliday() {
      getTodayHoliday()
        .then((result) => {
          console.log(result, 8899);
          this.hdImg = result && result.data && result.data.pcIconUrl;

          this.isVisible = this.hdImg ? true : false;

          // 判断是否需要展示弹框
          if (this.isVisible && this.shouldShowModal()) {
            this.isVisible = true;
          } else {
            this.isVisible = false;
          }
          // hdImg
        })
        .catch((err) => {
          console.log(err);
        });
    },
    zixun() {
      this.$router.push({
        path: "/pages/news/index",
      });
    },
    casetab(index) {
      this.casecur = index;
      this.curInfo = this.bannerList1[index];
    },
    changeTab(index1) {
      this.$router.push({
        path: "/pages/service/index",
        query: {
          id: index1,
        },
      });
    },
    getNewList1(item) {
      this.$router.push({
        path: "/pages/news/detail",
        query: { id: item.id, current: 2 },
      });
    },
    more() {
      this.$router.push("/pages/news/index");
    },
    gdjz(div, offset, callback) {
      console.log(div, offset, callback, "77777777777");
      this.$nextTick(() => {
        let dom = this.$refs[div]; // 等同于document.querySelector('.earth') true

        console.log(dom, 43322);
        if (dom) {
          var a, b, c, d;
          d = dom.offsetTop; // 元素距离相对父级的高度，这里父级指的是body
          a = eval(d + offset);
          b =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop; //  获取窗口滚动条高度
          c =
            document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
          if (b + c > a) {
            callback && callback();
          }
        }
      });
    },

    scrolling(e) {
      const winHeight =
        e.target.scrollTop || document.documentElement.scrollTop;

      console.log(
        winHeight,
        this.$refs.jiejuefangan.getBoundingClientRect().top,
        77777
      );

      if (winHeight >= 800) {
      }
      if (winHeight >= 800 && winHeight < 1000) {
      }
      if (winHeight >= 2200) {
        this.deviceShow = true;
      }
      if (winHeight >= 3400) {
        this.sceneShow = true;
      }
      if (winHeight >= 3800) {
        this.oemShow = true;
      }
    },
    contact() {
      this.$router.push({ path: "/pages/service/sub" });
    },

    detail(item) {
      this.$router.push({
        path: "/pages/case/detail",
        query: { id: item.id, current: 0 },
      });
    },
    getNewsList() {
      let that = this;
      //  行业资讯
      information({
        pageNum: 1,
        pageSize: 4,
        type: 2,
      })
        .then((result) => {
          this.newsList = result.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取公司动态列表
    getNewList(item) {
      this.$router.push({
        path: "/pages/case/detail",
        query: { id: item.id, current: 0 },
      });
    },
    getpermissions() {
      let that = this;
      permissions().then((response) => {
        this.caseList = response.rows;
        this.bannerList1 = response.rows;
        this.curInfo = this.bannerList1[0];
        this.$nextTick(() => {
          new Swiper(".case-banner", {
            autoplay: true,
            loop: true,
            slidesPerView: 3,
            spaceBetween: 0,
            // pagination: {
            //   el: ".case .swiper-pagination",
            // },
            navigation: {
              nextEl: ".case .swiper-button-next",
              prevEl: ".case .swiper-button-prev",
            },
            on: {
              slideChange: function () {
                that.curIndex = this.realIndex;
                console.log(this.realIndex, that.bannerList1, 33333);
              },
            },
          });
        });
      });
    },

    getBanner() {
      banners().then((response) => {
        this.bannerList = response.data;
        this.$nextTick(() => {
          new Swiper(".swiper-banner", {
            loop: true,
            autoplay: true,
            // spaceBetween: 30,
            effect: "fade",
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-banner .swiper-pagination",
              clickable: true,
            },
          });
        });
      });
    },
    getcompanyInfo() {
      companyInfo().then((response) => {
        this.info = response.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.addr {
  height: 727px;
  width: 100%;
  background: url("../../assets/ui3/addr.png") no-repeat;
  background-size: 100% 100%;
 
}

.container {
  width: 100%;

  background-color: #f0f0f0;
}

.content-item {
  /* margin: 20px 0; */
  /* height: 500px; */
  min-height: 500px;
}

.boxes {
  /* opacity: 0; */
  /* transform: translateY(20px); */
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.boxes.is-visible {
  opacity: 1;
  transform: translateY(0);
}
</style>

<style lang="less" scoped>
/deep/ .el-dialog {
  background: none !important;
  box-shadow: none !important;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  border: 1px solid #efefef;
  border-radius: 50%;
  padding: 5px;
}
.whychoice {
  margin: 95px 0 65px;
  display: flex;

  > div {
    position: relative;
    flex: 1;
    &:nth-child(2) {
      margin: 0 21px;
    }
    img {
      width: 100%;
    }
  }
  .info {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 52px;
    justify-content: center;
    .name1 {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #ffffff;
      line-height: 27px;
    }
    .desc {
      margin-top: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 30px;
    }
  }
}
.pad120 {
  padding-top: 120px;
}
// /deep/ .el-carousel__item--card{
//   transform:none !important;
// }

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.coperrator {
  // background: #ffede3;
  background: url("../../assets/ui3/3.png") no-repeat;
  background-size: cover;
  .title > div {
    color: #fff;
  }
  .box1 {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 170px;
      margin-right: 36px;
    }
  }
}

.mapBox {
  // width: 1204px;
  // margin: 0 auto;
  // display: flex;
  // background: url("https://www.xaryxx.com/images/images2/s10.png") no-repeat;
  // background-size: cover;
  // height: 320px;
  // padding: 83px 0 115px 0;
  // display: flex;
  // justify-content: space-between;
  // img {
  //   width: 350px;
  //   height: 367px;
  //   display: block;
  //   margin-right: 15%;
  //   margin-top: -30px;
  // }

  .infobox {
    padding: 0 10%;
    // width: 40%;
    // padding-left: 100px;
    display: flex;
    // flex-direction: column;
    align-items: flex-end;
    
    // justify-content: space-between;
    // height: 400px;
    .addricon{
      margin: 216px 0 30px 280px;
      align-self: flex-end;
    }
    .info1{
      width: 569px;
      height: 181px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 10px;
     background: url("../../assets/ui3/addrbg.png") no-repeat;
     background-size: 100% 100%;
      margin-left: 112px;
      // flex: 1;
      // padding: 0 28px 0 60px;
      padding-left: 61px;
      margin-bottom: 10px;
    }

    .zh {
      font-size: 25px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 37px;

      font-family: PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      // background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .en {
      margin-bottom: 15px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #898989;
      line-height: 37px;
    }

    .Certificates {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
    }

    .info > div {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 39px;
    }
  }
}

/deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.5) !important;
  opacity: 1;
  margin-right: 20px;
}

/deep/ .swiper-pagination-bullet-active {
  background: #ffffff !important;
}

.news {
  background: #ffffff;
  &.content {
    // display: inherit !important;
  }
  // background: linear-gradient(270deg, #ff891c 0%, #ff5e2b 99%);
  .title,
  .slogan {
    // color: #fff !important;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #f74f35;
  }
  .line {
    // background: #fff !important;
  }
  .more {
    width: 180px;
    height: 56px;
    border-radius: 75px;
    opacity: 1;

    background: rgba(216, 216, 216, 0);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: 500;

    color: #ffffff;
    border: 2px solid #ffffff;
    transition: all 0.5s;
    cursor: pointer;
    .img {
      margin-left: 8px;
    }

    &:hover {
      transform: scale(1.05);
      // background: #fff;
      // color:#ff5e2b ;
      .img {
        // color:#ff5e2b !important;
      }
    }
  }
  .innerBox {
    margin-top: 74px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .items {
      transition: all 0.5s;
      cursor: pointer;
      display: flex;
      align-content: center;
      justify-content: space-between;
      width: 46%;
      box-sizing: border-box;
      // margin-right: 3%;
      // height: 160px;
      padding: 24px;
      margin-bottom: 40px;
      // background: #fff;

      &:nth-child(2n) {
        margin-right: 0;
      }
      // &:hover {
      //   margin-top: -8px;
      // }
    }
    img {
      width: 210px;
      height: 144px;
      margin-right: 24px;
    }
    .info {
      flex: 1;
      .name {
        min-height: 52px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
      }
      .detail {
        margin: 18px 0 27px;
        min-height: 42px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
      .bottom {
        display: flex;
        align-content: center;
        justify-content: space-between;
        font-family: Arial;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        img {
          width: 29px;
          height: 29px;
        }
      }
    }
    .line1 {
      border: 1px solid #e5e5e5;
      margin: 26px 0;
    }
    .more1 {
      width: 110px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
      border: 1px solid #999999;
      // padding: 11px 18px 12px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
        margin-right: 9px;
      }
    }
    .bor {
      margin-top: 30px;
      height: 4px;
      background: #ff630e;
    }
    // justify-content: center;
  }
}

@media only screen and (min-width: 800px) and (max-width: 1400px) {
  .news {
    .left {
      .news-banner {
        width: 90%;

        .swiper-slide {
          margin-left: 10%;
        }
      }
    }
  }
}

.nav {
  justify-content: flex-start;
  padding: 20px 0;
  background: linear-gradient(139deg, #f64723 0%, #ea9933 100%);
}

.intro {
  margin-right: 10px;
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 49px;
}

.case {
  margin: 95px 0 2px;
  position: relative;
  .caseWrap {
    display: flex;
    flex-wrap: wrap;
    .item {
      border-bottom: 3px solid #fff;
      background: #ffffff;
      width: 32.5%;
      margin-bottom: 30px;
      &:nth-child(3n-1) {
        margin: 0 1.25% 30px;
      }

      transition: all 0.5s;
      .pic {
        width: 100%;
        height: 320px;
      }

      .pic {
        cursor: pointer;
        overflow: hidden;
      }

      img {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
      }

      &:hover {
        .pic img {
          transform: scale(1.2);
        }
        border-bottom: 3px solid #ff630e;
      }

      .infoWrap {
        padding: 30px 34px 30px;
      }
      .name1 {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
      }
      .desc {
        margin: 22px 0 14px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      .detail {
        display: flex;
        align-items: center;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #ff630e;
        i {
          margin-left: 10px;
        }
      }
    }
  }

  // .left {
  //   width: 324px;
  //   height: 400px;
  //   background: #ffffff;
  //   margin-right: 20px;
  //   padding: 30px 0 0;
  //   .item {
  //     cursor: pointer;
  //     margin-bottom: 10px;
  //     font-family: PingFang SC;
  //     font-weight: 400;
  //     font-size: 22px;
  //     color: #090909;
  //     padding: 16px 0;
  //     text-align: center;
  //     &.active {
  //       color: #ffffff;
  //       background: linear-gradient(90deg, #f7bea6, #ff5f19, #f7bea6);
  //     }
  //   }
  // }
  // .right {
  //   padding: 55px 73px 0 81px;
  //   flex: 1;
  //   background: #ffffff;
  //   .names {
  //     font-family: PingFang SC;
  //     font-weight: 400;
  //     font-size: 22px;
  //     color: #090909;
  //     margin-bottom: 33px;
  //   }
  //   .contents {
  //     font-family: PingFang SC;
  //     font-weight: 400;
  //     font-size: 18px;
  //     color: #090909;
  //     min-height: 38px;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     display: -webkit-box;
  //     -webkit-line-clamp: 2;
  //     -webkit-box-orient: vertical;
  //   }
  //   .detail {
  //     display: flex;
  //     align-items: center;
  //     // display: inline-flex;
  //     margin: 36px 0 43px 0;
  //     font-family: PingFang SC;
  //     font-weight: 400;
  //     font-size: 20px;
  //     color: #ff6019;
  //     line-height: 27px;
  //     // color: #ffffff;
  //     // background: #ff6019;
  //     border-radius: 30px;
  //     // padding: 13px 31px 11px;
  //     cursor: pointer;
  //   }

  //   .casetags {
  //     display: flex;
  //     flex-wrap: wrap;
  //     > div {
  //       width: 50%;
  //       display: flex;
  //       align-items: center;
  //       margin-bottom: 26px;
  //       font-family: PingFang SC;
  //       font-weight: 400;
  //       font-size: 18px;
  //       color: #090909;
  //       img {
  //         width: 28px;
  //         height: 32px;
  //         display: block;
  //         margin-right: 14px;
  //       }
  //     }
  //   }
  // }

  .swiper-wrapper {
    // margin: 0 25px;
  }
  .swiper-button-next {
    position: absolute;
    right: -80px;
    width: 58px;
    height: 58px;
    opacity: 1;
    background: #f7f3f3;
    border-radius: 50%;
    color: #fff;
    // border: 1px solid #ff3d00;
    i {
      font-size: 22px;
      color: #ff3d00;
      font-weight: bold;
    }

    &:hover {
      i {
        color: #fff;
      }
      border: none;

      background: linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);
    }

    // background: linear-gradient(90deg, #ff8400 1%, #e32200 101%);
  }
  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after,
  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    content: "--";
    //     display: inline-block;
    //     width: 80px;
    // height: 58px;

    // background: #EEEDED;
  }
  .swiper-button-prev {
    position: absolute;
    left: -80px;
    width: 58px;
    height: 58px;
    background: #f7f3f3;
    border-radius: 50%;
    color: #fff;
    // border: 1px solid #ff3d00;
    i {
      font-size: 22px;
      color: #ff3d00;
      font-weight: bold;
    }
    &:hover {
      i {
        color: #fff;
      }
      border: none;

      background: linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);
    }
    // background: linear-gradient(90deg, #ff8400 1%, #e32200 101%);
  }
  // height: 592px;

  .swiper-item {
    padding: 24px 32px 32px;
    background: #ffffff;
    margin: 15px;

    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
  }

  .touImg {
    min-height: 200px;
    // width: 316px;
    // height: 242px !important;
  }

  .name {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    padding: 24px 0;

    color: #666666;
  }

  .characteristic1 {
    margin: 25px 0;
    .descbox {
      min-height: 38px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 14px;
      color: #666;
    }

    .ul7 {
      margin: 25px 0 0 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap !important;

      > div {
        width: 50%;
        list-style-type: none;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        display: flex;
        align-items: center;

        .circle {
          margin-right: 10px;
          border-radius: 50%;
          width: 8px;
          height: 8px;
          background: #f14f02;
        }
        .infos {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .btns {
    width: 100%;
    // position: absolute;
    // bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    > div {
      // width: 200px;
      justify-content: center;
      display: flex;
      margin-right: 32px;
      width: 120px;
      &:last-child {
        margin-right: 0;
      }
      > div {
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        cursor: pointer;
        line-height: 29px;
        // padding: 15px 0;
        width: 120px;
        height: 40px;

        text-align: center;
        border-radius: 77px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.detail {
          color: #ffffff;
          background: linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);
        }

        &.concat {
          // align-self: flex-end;
          margin-right: 0;
          height: 36px;
          color: #565656;

          border: 2px solid #d7d7d7;

          // background: none;

          &:hover {
            color: #ffffff;
            height: 40px;
            border: 0;
            background: linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);
          }
        }
      }
    }
  }
  .info {
    flex: 1;
    display: flex;
    align-items: stretch;

    .left {
      flex: 1;
    }

    .right {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      flex: 1.8;
      margin-right: 190px;

      .desc {
        padding: 12px 0 0 0;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 23px;
      }

      .name {
        display: flex;
        align-items: center;
        font-size: 35px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 41px;

        .line {
          margin-right: 12px;
          width: 5px;
          height: 32px;
          background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
        }
      }
    }
  }

  .case-banner {
    flex: 1;
    overflow: hidden;

    .swiper-slide img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .swiper-slide {
      width: 80%;
    }
  }
}

.banner {
  position: relative;
  // display: flex;
  // flex-direction: column;

  img {
    width: 100%;
    // display: block;
    // height: auto;
  }
}

.content {
  display: flex;
  /*flex-direction: column;*/
  justify-content: space-around;

  .project {
    background-image: url("https://www.xaryxx.com/images/index_project.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    height: 696px;
    padding: 0 6%;
  }

  &.case {
    background-image: url("https://www.xaryxx.com/images/index_case.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  &.seat-box {
    background-image: url("https://www.xaryxx.com/images/index_seat.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    height: 200px;
  }

  .box {
    width: 75%;
    padding: 120px 0;

    .slogan {
      padding: 15px 0 33px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 23px;
      text-align: center;
      width: 100%;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #f74f35;
    }
    .serviceCont {
      margin-top: 95px;
      display: flex;
      align-items: center;
      .mid {
        margin: 0 21px;
        width: 513px;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      //  padding: 0 44px 0 34px;
      flex: 1;
      // display: flex;
      // flex-wrap: wrap;
      // align-items: center;
      // justify-content: space-between;

      li {
        background: url("../../assets/ui3/2.png") no-repeat;
        background-size: cover;
        height: 254px;
        display: flex;
        flex-direction: column;
        // align-items: center;
        // justify-content: center;
        position: relative;
        list-style-type: none;
        cursor: pointer;

        &:last-child {
          margin-top: 20px;
        }

        img {
          width: 80px;
          height: 80px;
          display: block;
          margin: 0 auto;
        }

        .name {
          width: 100%;
          text-align: left;
          font-size: 18px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
          margin: 57px 0 62px;
          padding-left: 34px;
        }

        .tags {
          padding-left: 34px;
          // width: 100%;
          // padding: 0 10px;

          > div {
            display: flex;
            // width: 280px;
            min-width: 400px;
            margin: 0 auto;
            margin-bottom: 15px;
          }

          > div > div {
            min-width: 200px;

            &:last-child {
              margin-right: 0;
            }

            display: flex;
            align-items: center;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333;
            line-height: 21px;

            span {
              margin-right: 8px;
              width: 16px;
              height: 16px;
              // background: #ababab;
              border-radius: 50%;
              background: url("https://www.xaryxx.com/images/images2/s15.png")
                no-repeat;
              background-size: cover;
            }
          }
        }

        // &:hover {
        //   background: #ffffff;
        //   box-shadow: 0px 8px 21px 0px rgba(0, 0, 0, 0.1);
        //   border-radius: 0px 0px 0px 0px;

        //   .decoration {
        //     display: block;
        //   }
        // }
      }
    }

    &.team {
      .slogan {
        text-align: center;
      }
      .contes {
        margin-bottom: 57px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div {
          position: relative;
          // width: 272px;
          // height: 260px;
          background: linear-gradient(0deg, #fff6f1, #ff5f19);
          margin-right: 36px;
          position: relative;
          flex: 1;
          list-style-type: none;

          &:last-child {
            margin-right: 0;
          }

          img {
            width: 90%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .infos {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 80px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            background: rgba(0, 0, 0, 0.55);
            .name {
              text-align: center;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              margin-bottom: 8px;
            }

            .desciption {
              text-align: center;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
            }
          }
        }
      }
    }

    .title {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 30px;
      color: #090909;
      text-align: center;

      .line {
        text-align: center;
        margin: 5px auto;
        width: 49px;
        height: 5px;
        background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
        border-radius: 0px 0px 0px 0px;
      }
    }

    .display-flex {
      .company-text {
        flex: 1;
        margin: 40px;
        text-align: left;

        p {
          text-indent: 30px;
        }
      }

      .company-image {
        width: 400px;
        height: 420px;

        img {
          width: 100%;
        }
      }

      .news-image {
        flex: 0 0 35rem;

        img {
          width: 100%;
        }

        .news {
          flex-direction: column;
          text-align: left;
          font-size: 1rem;
          flex: 1;
          margin-top: 0.5rem;
          padding-left: 2rem;
          position: relative;
        }
      }
    }

    .swiper-banner {
      width: 77rem;
      height: 834px;
      overflow: hidden;
    }
  }
}

.display-flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue